// Import Dependencies
import imagesLoaded from 'imagesloaded';
import Wallop from 'wallop';
import Hammer from 'HammerJS';
import ScrollMagic from 'scrollmagic';

// Import Components
import utilities from './components/utilities';
import map from './components/map';
import Pagination from './components/pagination';
import Collapsible from './components/collapse';
import OfficeMap from './components/officemap';
import Pin from './components/pin';
import MobileMenu from './components/mobilemenu';
import ReadMore from './components/readmore';
import Icons from './components/icons';
import FileUpload from './components/fileupload';
import VideoModal from './components/videomodal';
import CharLimit from './components/charlimit';
import './components/alert';

window.utilities = utilities;

class App {
  // Initialise Application Components
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      this.initScrollTo();
      this.initCarousel();
      this.initModal();
      this.initPagination();
      this.imagesLoaded = imagesLoaded(document.querySelector('.SiteMain'));
      this.imagesLoaded.on('always', () => {
        document.body.classList.add('is-loaded');
        this.initCollapseBlocks();
        this.initReadMore();
      });
      this.initOfficeMap();
      this.initMiniSearch();
      this.initFileUpload();
      this.initCharLimit();
      this.initScrollMagic();
      this.initIcons();
      this.initStaff();

      new MobileMenu(document.querySelector('.Nav-button'));
    });
  }

  // Initialise Smooth Loading
  smoothLoad() {
    window.onbeforeunload = () => {
      document.body.classList.remove('is-loaded');
    };
  }

  // Initialise ScrollTo
  initScrollTo() {
    // On click
    var links = document.querySelectorAll('a[href*="#"]');
    for ( var i = 0; i < links.length; i++ ) {
      links[i].addEventListener('click', scrollFunc);
    }

    function scrollFunc(e) {
      let index = this.getAttribute('href').indexOf('#');
      let href = this.getAttribute('href').substr(index+1);
      let el = document.getElementById(href);
      if ( el ) {
        e.preventDefault();
        let boundingBox = el.getBoundingClientRect();
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let to = boundingBox.top + scrollTop;

        TweenLite.to(window, 1, {scrollTo:{y:to}, ease:Power2.easeOut});
        if ( el.classList.contains('Collapse-anchor') && ! el.parentElement.classList.contains('is-open') ) {
          el.nextElementSibling.click();
        }
      }
    }
  }

  // Initialise Carousels
  initCarousel() {
    let carousels = document.querySelectorAll('[data-js="carousel"]');

    if ( carousels === null )
      return false;

    this.carousels = [];

    let opt = {
      itemClass: 'js-slide',
      currentItemClass: 'is-active',
      showPreviousClass: 'Hero-image--showPrevious',
      showNextClass: 'Hero-image--showNext',
      hidePreviousClass: 'Hero-image--hidePrevious',
      hideNextClass: 'Hero-image--hideNext',
    };

    for ( var i = 0; i < carousels.length; i++ ) {
      this.carousels.push(new Wallop(carousels[i], opt));
    }

    setInterval(function(){
      for ( var i = 0; i < carousels.length; i++ ) {
        app.carousels[i].next();
      }
    }, 5000);
  }

  // Initialise Video Modals
  initModal() {
    let modalEl = document.querySelector('[data-js="modal"]');
    if ( ! modalEl )
      return false;

    this.modal = new VideoModal(modalEl, {
      open: '[data-js="modal-open"]',
      close: '[data-js="modal-close"]'
    });
  }

  // Initialise Collapsible Blocks
  initCollapseBlocks() {
    let elements = document.querySelectorAll('[data-js="collapse"]');

    if ( elements === null )
      return false;

    let opt = {
      selectors: {
        head: '[data-js="collapse-header"]',
        body: '[data-js="collapse-body"]',
        intro: '[data-js="collapse-intro"]',
        content: '[data-js="collapse-content"]',
      }
    };

    this.collapsibles = [];
    for ( let i = 0; i < elements.length; i++ ) {
      this.collapsibles.push(new Collapsible(elements[i], opt));
    }
  }

  // Initialise Office Map
  initOfficeMap() {
    let officeMapEl = document.querySelector('[data-js="officemeta"]');

    if ( officeMapEl === null )
      return false;

    let opt = {
      pins: '[data-js="pin"]',
      meta: {
        name: '[data-js="officemeta-name"]',
        established: '[data-js="officemeta-established"]',
        address: '[data-js="officemeta-address"]',
        description: '[data-js="officemeta-description"]'
      },
      button: '[data-js="officemeta-website"]'
    };

    this.officeMap = new OfficeMap(officeMapEl, opt);
  }

  // Initialise Read More
  initReadMore() {
    let readMoreEls = document.querySelectorAll('[data-js="readmore"]');

    if ( ! readMoreEls.length )
      return false;

    this.readMore = [];

    let opt = {
      selectors: {
        trigger: '[data-js="readmore-button"]',
        content: '[data-js="readmore-content"]'
      }
    };

    for ( let i = 0; i < readMoreEls.length; i++ ) {
       this.readMore.push(new ReadMore(readMoreEls[i], opt));
    }
  }

  // Initialise MiniSearch
  initMiniSearch() {
    this.minisearch = false;
    let form = document.querySelector('[data-js="minisearch"]');
    let input = document.querySelector('[data-js="minisearch-input"]');
    let button = document.querySelector('[data-js="minisearch-button"]');
    let inputWrap = document.querySelector('[data-js="minisearch-wrap"]');
    let nav = document.querySelector('.Nav');

    let toggle = () => {
      this.minisearch = ! this.minisearch;
      inputWrap.classList.toggle('is-open');
      nav.classList.toggle('has-minisearch');
    };

    let close = () => {
      if ( inputWrap.classList.contains('is-open') ) {
        toggle();
      }
    };

    let inputChange = (e) => {
      let value = input.value;
      button.setAttribute('type', value.length ? 'submit' : 'button');
    };

    button.addEventListener('click', toggle);
    input.addEventListener('keyup', inputChange);

    document.addEventListener('click', (e) => {
      if ( ! form.contains(e.target) ) {
        close();
      }
    });

    document.addEventListener('keyup', (e) => {
      if ( e.keyCode == 27 ) {
        close();
      }
    });
  }

  // Initialise Bulletin Pagination
  initPagination() {
    let pages = document.querySelector('[data-js="pagination"]');

    if ( pages === null )
      return false;

    let opt = {
      itemClass: 'js-page',
      currentItemClass: 'is-active',
      showPreviousClass: 'List-page--showPrevious',
      showNextClass: 'List-page--showNext',
      hidePreviousClass: 'List-page--hidePrevious',
      hideNextClass: 'List-page--hideNext',
      dots: true,
      arrows: true,
      dynamicHeight: true,
      buttonPreviousClass: 'js-prev',
      buttonNextClass: 'js-next',
      dotClass: 'js-dot',
      wrapperClass: 'js-wrapper'
    };

    this.pagination = new Pagination(pages, opt);
  }

  // Initialise CV File Uploads
  initFileUpload() {
    let fileUploads = document.querySelectorAll('input[type="file"]');
    if ( ! fileUploads )
      return;

    this.fileUploads = [];

    for ( let i = 0; i < fileUploads.length; i++ ) {
      this.fileUploads.push(new FileUpload(fileUploads[i]));
    }
  }

  // Initialise Textarea Character Limit
  initCharLimit() {
    let charLimitEl = document.querySelector('[data-charlimit]');
    if ( ! charLimitEl )
      return;

    this.charLimit = new CharLimit(charLimitEl);
  }

  // Initialise ScrollMagic Scenes
  initScrollMagic() {
    // Create Controller
    this.controller = new ScrollMagic.Controller();

    // Header Scrolling Trigger
    const headerEl = document.querySelector('.Header');
    if ( headerEl ) {
      const subheaderEl = document.querySelector('.Nav-subBg');
      const headerTween = TweenMax.fromTo(headerEl, 1, {backgroundColor: 'rgba(0,81,186,.8)'}, {backgroundColor: 'rgba(0,81,186,1)', paused: true});
      const submenuTween = TweenMax.fromTo(subheaderEl, 1, {backgroundColor: 'rgba(0, 69, 152, .8)'}, {backgroundColor: 'rgba(0, 71, 159, 1)', paused: true});

      if ( document.querySelector('.Hero') ) {
        const headerSceneEl = document.querySelector('.Hero');
        const headerScene = new ScrollMagic.Scene({
          triggerElement: headerSceneEl,
          triggerHook: "onLeave",
          duration: 400,
        });

        headerScene.on("progress", function(event) {
          headerTween.progress(event.progress);
          submenuTween.progress(event.progress);
        });
        headerScene.addTo(this.controller);

      } else {
        headerTween.progress(1);
        submenuTween.progress(1);
      }
    }

    // Hero Scroll Effect
    var heroImages = document.querySelector('.Hero-parallax') || document.querySelector('.Hero-photo');

    if ( heroImages ) {
      const heroTween = TweenMax.fromTo(heroImages, 2, {y: -50, opacity: 1}, {y: 100, opacity: 0.5, paused: true});

      var heroSceneEl = document.querySelector('.Hero');
      var duration = heroSceneEl.offsetHeight;
      var heroScene = new ScrollMagic.Scene({
        triggerElement: heroSceneEl,
        triggerHook: "onLeave",
        duration: duration
      });

      heroScene.on("progress", function(event) {
        heroTween.progress(event.progress);
      });
      heroScene.addTo(this.controller);
    }

    // Compass Scroll Effect
    var compassEl = document.querySelector("[data-js=sm-compass]");

    if ( compassEl ) {
      // Create Tween
      const compassTween = TweenMax.fromTo(compassEl, 1, {y: 50}, {y: -30, paused: true});

      // Create Scene
      var compassSceneEl = document.querySelector("[data-js=sm-notices]");
      var compassScene = new ScrollMagic.Scene({
        triggerElement: compassSceneEl,
        duration: compassSceneEl.offsetHeight
      });

      // Progress tween over scene
      compassScene.on("progress", function(event) {
        compassTween.seek(event.progress);
      });

      compassScene.addTo(this.controller);
    }
  }

  // Initialise Icon Animations
  initIcons() {
    this.icons = new Icons();

    var iconSceneEl = document.querySelector('[data-js=sm-icons]');
    var iconScene = new ScrollMagic.Scene({
      triggerElement: iconSceneEl,
      reverse: false
    });

    iconScene.on("enter", (e) => {
      this.icons.timeline().play();
      iconScene.enabled(false);
    });

    iconScene.addTo(this.controller);
  }

  // Initialise Carousels
  initStaff() {
    
    let carouselEl = document.querySelector('[data-js="staff"]');
    
    if ( carouselEl === null )
      return false;

    // if (window.innerWidth > 767 )
    //   return false;

    let buttons = carouselEl.querySelectorAll('[data-button]');

    let opt = {
      itemClass: 'Staff-member',
      currentItemClass: 'is-active',
      showPreviousClass: 'Staff-member--showPrevious',
      showNextClass: 'Staff-member--showNext',
      hidePreviousClass: 'Staff-member--hidePrevious',
      hideNextClass: 'Staff-member--hideNext',
    };

    let carousel = new Wallop(carouselEl, opt);

    let carouselTimer = setInterval(function () {
        carousel.next();
    }, 5000);

    let hammertime = new Hammer(carouselEl);
    hammertime.on('swiperight', function (ev) {
      carousel.previous();
      clearInterval(carouselTimer);
    });
    hammertime.on('swipeleft', function (ev) {
      carousel.next();
      clearInterval(carouselTimer);
    });

    carouselEl.querySelector('[data-button="prev"]').addEventListener("click", function () {
      carousel.previous();
    });

    carouselEl.querySelector('[data-button="next"]').addEventListener("click", function () {
      carousel.next();
    });
    
  
  }
}

window.app = new App();



// WEBPACK FOOTER //
// ./scripts/app.js